// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    getRacfId,
    updateUser
} from '../../shared/repositories';
import actions from '../../actions-list';
import {getStore} from '../../../store-factory';
import {getUserSecurity} from '../repositories';
import {readLinks} from '../../../app/action-creators/links';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateIsInitialLoad} from '../../../reimbursement-summary/summary/action-creators/is-initial-load';
import {updateWalkMeLanguage} from '../../../shared/services/walkme';

export const updateUserSettings = () =>

    async (dispatch, getState) => {

        const user = getState().user.details;

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await updateUser(user);

            const newUser = await getUserSecurity(getStore());

            dispatch({
                data: newUser,
                type: actions.UPDATE_USER_PREFERENCES_SUCCESS
            });

            successAlertBar(translate('USER_PREFERENCES_UPDATED'));

            dispatch({
                data: true,
                type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
            });

            updateIsInitialLoad(true)(dispatch);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const updateUserLanguageSettings = () =>

    async (dispatch, getState) => {

        const user = getState().user.details;

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await updateUser(user);

            const newUser = await getRacfId(getStore());

            dispatch({
                data: newUser,
                type: actions.UPDATE_USER_PREFERENCES_SUCCESS
            });

            successAlertBar(translate('USER_PREFERENCES_UPDATED'));

            dispatch({
                data: true,
                type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
            });

            readLinks()(dispatch);

            updateWalkMeLanguage(getState().user.details.getLocale());

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };
export const resetUserSettings = nextLocation =>

    async dispatch => {

        try {

            await getRacfId(getStore());

            dispatch({
                data: true,
                type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
            });

            dispatch(routerActions.push(nextLocation));

        } catch (error) {

        }

    };



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/user.js